module.exports = __webpack_public_path__ + "img/logo-m2n.d407f15a.svg";